<div>
  <div class="header">
    <h3>{{ dialogData.title | translate | uppercase }}</h3>
    <mat-icon (click)="closeModalWindow()" class="close-icon">clear</mat-icon>
  </div>

  <div class="form" [formGroup]="exportDataFromGroup">

    <div class="date-range-picker">
      <mat-form-field>
        <mat-label>Date range</mat-label>
        <mat-date-range-input [rangePicker]="picker" disabled>
          <input matStartDate placeholder="Start date" formControlName="startDate">
          <input matEndDate placeholder="End date" formControlName="endDate">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker [disabled]="false"></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="ranges">
      <mat-chip-list>
        <mat-chip *ngFor="let range of rangeOptions"
                  (click)="onSelectDateRange(range)"
        >{{ range.title | translate }}</mat-chip>
      </mat-chip-list>
    </div>

    <mat-form-field class="team-project" *ngIf="!identityService.isTeamAdmin()">
      <mat-label>Project Name</mat-label>
      <mat-select formControlName="teamSlug">
        <mat-option *ngFor="let team of teamsProjects" [value]="team.Slug">
          {{ team.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="include-archived">
      <mat-slide-toggle color="primary" formControlName="includeArchived">{{ 'exportDataModal.includeArchived' | translate }}</mat-slide-toggle>
    </div>

    <div class="export-button" (click)="onExportData()">
      <button mat-raised-button color="primary" [disabled]="!exportDataFromGroup.valid">
        {{ 'exportDataModal.exportAsCsv' | translate | uppercase }}
      </button>
    </div>
  </div>
</div>
